import { GQL_ID } from '@@partner:types:graphql'
import React from 'react'
import { Checkbox, RadioGroup, Radio, Toggle, Panel } from 'rsuite'

import './ZoneLegend.scss'

export type LegendMode = 'shops' | 'providers'

export interface LegendItem {
  id: GQL_ID | string
  name: string
  address?: string
  color: string
  isActive?: boolean
}

interface ZoneLegendProps {
  mode: LegendMode
  onModeChange: (mode: LegendMode) => void
  items: LegendItem[]
  selectedIds: Set<GQL_ID | string>
  onItemToggle: (id: GQL_ID | string) => void
  showAllShops?: boolean
  onShowAllShopsChange?: (value: boolean) => void
  onSelectAll: () => void
  onDeselectAll: () => void
}

export default function ZoneLegend ({
  mode,
  onModeChange,
  items,
  selectedIds,
  onItemToggle,
  showAllShops = false,
  onShowAllShopsChange,
  onSelectAll,
  onDeselectAll
}: ZoneLegendProps) {
  const visibleItems = mode === 'shops' && !showAllShops
    ? items.filter(item => item.isActive !== false)
    : items

  const allSelected = visibleItems.every(item => selectedIds.has(item.id))
  const noneSelected = visibleItems.every(item => !selectedIds.has(item.id))

  return (
    <div className="ZoneLegend">
      <Panel bordered header="Легенда" collapsible defaultExpanded={false}>
        <div className="ZoneLegend__mode">
          <RadioGroup
            inline
            appearance="picker"
            value={mode}
            onChange={(value) => onModeChange(value as LegendMode)}
          >
            <Radio value="shops">По магазинам</Radio>
            <Radio value="providers">По провайдерам</Radio>
          </RadioGroup>
        </div>

        {mode === 'shops' && onShowAllShopsChange && (
          <div className="ZoneLegend__filter">
            <Toggle
              size="sm"
              checked={showAllShops}
              onChange={onShowAllShopsChange}
              checkedChildren="Все"
              unCheckedChildren="Активные"
            />
          </div>
        )}

        <div className="ZoneLegend__actions">
          <button 
            className="ZoneLegend__action-btn"
            onClick={onSelectAll}
            disabled={allSelected}
          >
            Выбрать все
          </button>
          <button 
            className="ZoneLegend__action-btn"
            onClick={onDeselectAll}
            disabled={noneSelected}
          >
            Снять все
          </button>
        </div>

        <div className="ZoneLegend__list">
          {visibleItems.map(item => (
            <div 
              key={item.id} 
              className={`ZoneLegend__item ${selectedIds.has(item.id) ? 'ZoneLegend__item--selected' : ''}`}
              onClick={() => onItemToggle(item.id)}
            >
              <div 
                className="ZoneLegend__color" 
                style={{ backgroundColor: item.color }}
              />
              <div className="ZoneLegend__info">
                <span className="ZoneLegend__name">
                  {item.name}
                  {item.isActive === false && <span className="ZoneLegend__inactive"> (неактивен)</span>}
                </span>
                {item.address && (
                  <span className="ZoneLegend__address">{item.address}</span>
                )}
              </div>
              <Checkbox 
                checked={selectedIds.has(item.id)}
                onChange={() => {}}
              />
            </div>
          ))}
        </div>

        <div className="ZoneLegend__stats">
          Выбрано: {selectedIds.size} из {visibleItems.length}
        </div>
      </Panel>
    </div>
  )
}
